import * as React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Fade } from 'react-reveal'

import LoadingBase from '../../loading/LoadingBase/LoadingBase'

import media from '../../../services/generateMediaQueries'

import ZingIcon from '../../../assets/img/zing-icon.svg'

let LOADING = false

const CardWrapper = styled.div`
  outline: none;
  ${media.lessThan('small')`
    width: 100%;
  `}
`

const CardImage = styled.div.attrs(props => ({
  style: {
    background: `linear-gradient(to bottom , transparent, rgba(0, 0, 0, 0.8)),
    linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)), url('${props.cardImageUrl}') 0% 0% / cover, linear-gradient(#000000, #000000)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
}))`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #000000;
  transition: all 0.5s;
`

const StyledCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 244px;
  height: 300px;
  border-radius: var(--border-radius-card);
  box-shadow: var(--box-shadow-large);
  overflow: hidden;
  background: linear-gradient(
      rgba(141, 122, 157, 0.4),
      rgba(141, 122, 157, 0.4)
    ),
    #f9f9f9;

  ${media.lessThan('small')`
    flex-direction: row;
    height: 94px;
    width: 100%;
    border-radius: 5px;
    background: #ffffff;
    margin-left: 0 !important;
    margin-right: 0 !important;
  `}

  &:hover {
    ${CardImage} {
      transform: scale(1.2);
    }
  }
`

const CardImageWrapper = styled.div`
  ${media.lessThan('small')`
    position: relative;
    min-width: 94px;
    height: 94px;
    border-radius: 5px 0 0 5px;
    overflow: hidden;
    z-index: 1;
  `}
`

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  padding: 1.125rem 2rem 2.75rem;
  height: 100%;
  text-align: center;
  z-index: 1;

  ${media.lessThan('small')`
    flex-direction: row-reverse;
    flex: 1;
    height: 100%;
    padding: 1rem;
    align-items: flex-start;

    > div  {
      text-align: left;
    }
  `}
`

const MerchantDetails = styled.div`
  flex: 0 0 auto;

  ${media.lessThan('small')`
    flex: 1 1 auto;
  `}
`

const RewardsCountContainer = styled.div`
  flex: 1 1 auto;

  ${media.lessThan('small')`
    flex: 0 0 auto;
  `}
`

const RewardsCount = styled.h3`
  color: #ffffff;
  font-size: 0.75rem;
  text-transform: uppercase;

  margin: 0;
  padding: 0.25rem 0.5rem;

  background: rgba(255, 255, 255, 0.5);
  border-radius: var(--border-radius-small);

  ${media.lessThan('small')`
    font-size: 0.625rem;
    padding: 0;
    line-height: 1.5rem;
    color: var(--color-primary);
    font-weight: var(--font-weight-bold);
  `}
`

const LogoWrapper = styled.div`
  display: none;
  ${media.greaterThan('small')`
    height: 4rem;
    width: 4rem;
    display: grid;
    place-content: center;
    margin: 0 auto 1rem;
    background-color: white;
  `}
`

const LogoWrapperMobile = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: white;
  transition: all 0.5s;
  display: grid;
  place-content: center;
  ${media.greaterThan('small')`
    display: none;
  `}
`

const Logo = styled.img`
  width: 100%;
`

const MerchantName = styled.h3`
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: var(--font-weight-bold);
  line-height: 1.5625rem;
  text-shadow: var(--text-shadow);
  min-height: calc(1.5625rem * 2);
  margin: 0;
  margin-bottom: 1.25rem;

  ${media.lessThan('small')`
    color: #000000;
    font-size: 0.875rem;
    line-height: 1.1875rem;
    min-height: calc(1.1875rem * 2);
    text-shadow: none;
    margin-bottom: 0.3rem;
  `}
`

const Tagline = styled.p`
  font-size: 0.875rem;
  line-height: 1.1875rem;
  text-shadow: var(--text-shadow);
  margin: 0;

  ${media.lessThan('small')`
    font-size: 0.625rem;
    line-height: 0.875rem;
    text-shadow: none;
  `}
`

const StyledLink = styled(Link)`
  text-decoration: none;
`

const Text = styled.p`
  margin: 0;
  font-weight: 500;
  text-align: center;

  ${media.greaterThan('small')`
    color: #ffffff;
  `}
`

const PlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  ${media.lessThan('small')`
    flex-direction: row;
    justify-content: unset;
    align-items: unset;
  `}
`

const ZingIconComponent = styled.img.attrs({ src: ZingIcon })`
  margin-bottom: 1rem;

  ${media.lessThan('small')`
    flex: 0 0 auto;
    padding: 1.25rem;
    margin-bottom: 0;
  `}
`

const ErrorWrapper = styled.div`
  ${media.lessThan('small')`
    flex: 1 1 auto;
    padding: 1.25rem;
    text-align: left;
  `}
`

const LoadingWrapper = styled.div`
  flex: 0 0 auto;
  display: none;
  padding: 1rem;
  text-align: left;

  ${media.lessThan('small')`
    flex: 1 1 auto;
    display: block;
  `}
`

function CatalogCard(props) {
  const {
    data = {},
    to = '',
    id,
    loading,
    error,
    errorMessage,
    onRetry,
    logoUrl,
    ...restProps
  } = props

  const {
    name = null, // rewards
    tagLine = null,
    rewardsCount,
    tileImageUrl,
    imageUrl,
    title, // offers
    body,
    onClick,
  } = data || {}

  LOADING = loading

  const CardComponent = () => (
    <CardWrapper {...restProps}>
      <StyledLink
        to={to}
        onClick={
          loading
            ? e => {
                e.preventDefault()
                if (error) {
                  onRetry()
                }
              }
            : onClick
        }
      >
        <StyledCard>
          {!LOADING ? (
            <>
              <CardImageWrapper>
                <CardImage cardImageUrl={tileImageUrl || imageUrl} />
                {logoUrl && (
                  <LogoWrapperMobile>
                    <Logo src={logoUrl} alt={name} />
                  </LogoWrapperMobile>
                )}
              </CardImageWrapper>
              <CardContent>
                {rewardsCount && (
                  <RewardsCountContainer>
                    <RewardsCount>{rewardsCount} rewards</RewardsCount>
                  </RewardsCountContainer>
                )}
                <MerchantDetails>
                  {logoUrl && (
                    <LogoWrapper>
                      <Logo src={logoUrl} alt={name} />
                    </LogoWrapper>
                  )}
                  <MerchantName>{name || title}</MerchantName>
                  <Tagline>{tagLine || body}</Tagline>
                </MerchantDetails>
              </CardContent>
            </>
          ) : (
            <PlaceholderWrapper>
              <ZingIconComponent />
              {error ? (
                <ErrorWrapper>
                  <Text>{errorMessage || 'Failed to load Explore.'}</Text>
                  <Text>Tap to retry.</Text>
                </ErrorWrapper>
              ) : (
                <LoadingWrapper>
                  <LoadingBase size="small" lines={1} />
                </LoadingWrapper>
              )}
            </PlaceholderWrapper>
          )}
        </StyledCard>
      </StyledLink>
    </CardWrapper>
  )

  if (LOADING) {
    return <CardComponent />
  }

  return (
    <Fade right distance="1rem" delay={300 + 50 * id} duration={300} force>
      <CardComponent />
    </Fade>
  )
}

CatalogCard.defaultProps = {
  // TODO: specify default props
}

CatalogCard.propTypes = {
  // TODO: specify prop types
}

export default CatalogCard
